<div
    class="bg-white rounded-t-2xl sm:rounded-lg w-full max-w-3xl max-h-[100vh] sm:h-auto sm:max-h-[90vh] overflow-y-auto shadow-lg mobile-scroll animate-slide-up-mobile sm:animate-none">
    <div
        class="flex justify-between items-center mobile-container mobile-safe-top !border-b !border-gray-200 !border-opacity-50">
        <div class="swipe-indicator sm:hidden"></div>
        <div
            class="flex flex-col sm:flex-row sm:items-center space-y-[8px] sm:space-y-[0px] sm:space-x-[10px] flex-1 p-[10px]">
            <h2 class="text-responsive-lg !font-semibold text-gray-900 !mb-0 pr-6">
                {{ onGoinfShftData?.jobPlace?.jobPlaceName ? onGoinfShftData?.jobPlace?.jobPlaceName : '-' }}
            </h2>
        </div>
        <button
            (click)="closeModal()"
            class="mobile-touch-target flex items-center justify-center text-gray-400 hover:text-gray-600 touch-feedback ml-4"
            aria-label="Close" style="margin: 12px;">
            <svg
                class="lucide lucide-x"
                fill="none"
                height="22"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                viewBox="0 0 24 24"
                width="22"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6 6 18"></path>
                <path d="m6 6 12 12"></path>
            </svg>
        </button>
    </div>

    <div class="mobile-container mobile-space-y-[24px] p-4">
        <div
            class="relative p-[16px] bg-gradient-to-br from-muted to-muted/50 rounded-lg border border-border/50 shadow-sm">
            <h3
                class="text-[14px] font-semibold text-foreground mb-[4px] flex items-center">
                {{'guard-shift-details.onGoing.mission-status' | translate}}
            </h3>
            <div class="flex items-center justify-between mt-[-2px] flex-wrap gap-2">
                <div class="flex items-center">
                    <div class="relative group">
                        <span
                            class="inline-flex items-center rounded-full font-medium bg-green-50 text-green-700 px-[10px] py-[4px] text-[14px]">
                            <span class="flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg"
                                    width="14" height="14" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor"
                                    strokeWidth="{2}" strokeLinecap="round"
                                    strokeLinejoin="round"
                                    class="lucide lucide-activity text-cyan-500">
                                    <path
                                        d="M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2" />
                                </svg>
                                <span
                                    class="ml-[4px]">{{displayStatus(onGoinfShftData?.status)}}</span>
                            </span>
                        </span>
                    </div>
                    @if ((onGoinfShftData?.guardsNumber ?? 0) && (onGoinfShftData?.guardsHiredCount ?? 0)) {
                    <span class="ml-[8px] text-[14px] text-muted-foreground">
                        {{ onGoinfShftData?.guardsHiredCount ?? 0 }} 
                        {{ 'guard-shift-details.onGoing.of' | translate }} 
                        {{ onGoinfShftData?.guardsNumber ?? 0 }} 
                        {{ 'guard-shift-details.onGoing.seats-filled' | translate }}
                    </span>
                    }
                </div>
            </div>
        </div>
        <!-- Ring Section -->

        @if(onGoinfShftData.guardsNumber > 0)
        {
            <div
                class="bg-[#ffff] border-[1px] bg-muted/30 rounded-lg border border-border/50 rounded-[8px] p-4 mt-6 shadow-sm">
                <h3
                    class="text-[18px] font-[700] !text-[#166534] mb-[12px] flex items-center gap-[8px]">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                        viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                        class="text-green-600">
                        <path d="M21.801 10A10 10 0 1 1 17 3.335" />
                        <path d="m9 11 3 3L22 4" />
                    </svg>
                    {{ 'guard-shift-details.onGoing.checked-in-guards' | translate }} ( {{ onGoinfShftData?.guardsNumber }}/{{
                    onGoinfShftData?.guardsHiredCount }} )
                </h3>
                <div class="grid gap-[12px]">
                    <div class="space-y-2">
                        @if(onGoinfShftData?.hired.length > 0 ) { @for(data of
                        onGoinfShftData?.hired; track (data?.id ? data.id + '-' + $index : $index)) {
                        <!-- 🟧 ORANGE BLOCK: if startTime > checkinTime -->
                       @if(data?.shiftDetails?.checkinTime) {
                        @if (isStartAfterCheckin(onGoinfShftData?.startTime,
                        onGoinfShftData?.checkinTime)) {
                        <div
                            class="flex items-center justify-between px-[12px] py-[12px] bg-orange-50 rounded-lg border border-orange-200 cursor-pointer hover:bg-orange-100 transition-colors">
                            <div class="flex items-center gap-[12px]">
                                <div class="relative">
                                    @if (data?.image) {
                                    <img [src]="data?.image"
                                        [alt]="data?.firstName || 'User Image'"
                                        class="w-[48px] h-[48px] rounded-full object-cover"
                                        loading="lazy" />
                                    } @else if (data?.firstName || data?.aliasName) {
                                    <div
                                        class="w-[48px] h-[48px] rounded-full bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center text-blue-700 font-bold text-sm ring-2 ring-background shadow-sm">
                                        {{ (data?.aliasName?.charAt(0) || data?.firstName?.charAt(0)) || '-' }}
                                    </div>
                                    }
                                    <div
                                        class="absolute -bottom-[4px] -right-[4px] w-[16px] h-[16px] bg-orange-500 rounded-full border-[2px] border-white flex items-center justify-center">
                                        <div
                                            class="w-[6px] h-[6px] bg-white rounded-full"></div>
                                    </div>
                                </div>
                                <div class="flex-1 min-w-0">
                                    <div class="font-medium text-[14px]">
                                        {{(data?.aliasName ? data.aliasName : (data?.firstName ? data.firstName : '-')) }}
                                    </div>
                                    <div class="text-[12px] text-orange-600">{{
                                        'guard-shift-details.common.estimate-arrival' | translate }}: {{ getMinutesLate(onGoinfShftData?.startTime, data?.shiftDetails?.checkinTime) }} minutes
                                    </div>
                                </div>
                            </div>
                            <a href="javascript:void(0)" *ngIf="data.phone"
                                [href]="'tel:' + data.phone"
                                class="px-[16px] py-[8px] bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors font-medium text-[14px] flex items-center gap-[8px] call-button">
                                Ring
                            </a>
                        </div>
                        } @else{
                        <div
                            class="flex items-center justify-between px-[12px] py-[12px] bg-green-50 rounded-lg border border-green-200 cursor-pointer hover:bg-green-100 transition-colors">
                            <div class="flex items-center gap-[12px]">
                                <div class="relative">
                                    @if (data?.image) {
                                    <img [src]="data?.image"
                                        [alt]="data?.firstName || 'User Image'"
                                        class="w-[48px] h-[48px] rounded-full object-cover"
                                        loading="lazy" />
                                    } @else if (data?.firstName || data?.aliasName) {
                                    <div
                                        class="w-[48px] h-[48px] rounded-full bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center text-blue-700 font-bold text-sm ring-2 ring-background shadow-sm">
                                        {{ (data?.aliasName?.charAt(0) || data?.firstName?.charAt(0)) || '-' }}
                                    </div>
                                    }
                                    <div
                                        class="absolute -bottom-[4px] -right-[4px] w-[16px] h-[16px] bg-green-500 rounded-full border-[2px] border-white flex items-center justify-center">
                                        <div
                                            class="w-[6px] h-[6px] bg-white rounded-full"></div>
                                    </div>
                                </div>
                                <div class="flex-1 min-w-0">
                                    <div class="font-medium text-[14px]">
                                        {{ (data?.aliasName ? data.aliasName : (data?.firstName ? data.firstName : '-')) }}
                                    </div>
                                    <div class="text-[12px] text-green-600">
                                        {{ 'guard-shift-details.finish.check-in' |
                                        translate }}&nbsp; {{
                                        data?.shiftDetails?.checkinTime | date:
                                        'HH:mm' }}
                                    </div>
                                </div>
                            </div>
                            <a href="javascript:void(0)" *ngIf="data.phone"
                                [href]="'tel:' + data.phone"
                                class="px-[16px] py-[8px] bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors font-medium text-[14px] flex items-center gap-[8px] call-button">
                                Ring
                            </a>
                        </div>
                        }
                   }  } } @else{
                            <p>{{ 'guard-shift-details.onGoing.guard-not-found' | translate }}</p>
                        }
                    
                    </div>
                </div>
            </div>
        }

        <div [class]="onGoinfShftData?.hired?.length > 0 ? 'space-y-[32px]' : 'space-y-[16px]'">
            <div [class]="onGoinfShftData?.hired?.length > 0 ? 'space-y-[8px]' : ''">
                <h3
                    [class]="'text-[14px] !font-semibold text-foreground flex items-center ' + (onGoinfShftData?.hired?.length > 0 ? '!mb-[12px] !mt-[24px]' : '!mb-[8px] !mt-[16px]')">
                    {{'guard-shift-details.onGoing.booked-guards' | translate}}:
                      {{ onGoinfShftData?.guardsHiredCount ?? (onGoinfShftData?.hired ? onGoinfShftData.hired?.length : 0)
                    }}
                </h3>
                <div [class]="onGoinfShftData?.hired?.length > 0 ? 'grid grid-cols-1 sm:grid-cols-2 gap-[12px]' : ''">
                    @for(data of onGoinfShftData.hired; track (data?.id ? data.id + '-' + $index : $index)) {
                    <div (click)="showGuardDetails(data)"
                        class="flex items-center gap-[12px] p-[12px] bg-muted/30 rounded-lg border border-border/50 cursor-pointer hover:bg-muted/40 transition-colors shadow-sm">
                        <div class="relative">
                            @if(data?.image) {
                            <img alt="Guard Image"
                                class="w-[48px] h-[48px] rounded-full object-cover"
                                src="{{data?.image}}" loading="lazy" />
                            } @else{
                            <div
                                class="w-[48px] h-[48px] rounded-full bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center text-blue-700 font-bold text-sm ring-2 ring-background shadow-sm">
                                {{ (data?.aliasName?.charAt(0) ? data?.aliasName?.charAt(0) : data?.firstName?.charAt(0)) || '-' }}
                            </div>
                            } @if(totalShiftsForCustomer > commonConstants.TOTAL_CUSTOMER_SHIFT_MORE_THAN_SEVENTY)
                            {
                            <div
                                class="absolute -bottom-1 -right-1 bg-green-600 rounded-full p-[4px]">
                                <svg fill="none" height="16" viewBox="0 0 24 24"
                                    width="16"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M9 16.2L4.8 12L3.4 13.4L9 19L21 7L19.6 5.6L9 16.2Z"
                                        fill="white"></path>
                                </svg>
                            </div>
                            }
                        </div>
                        <div class="flex-1 min-w-0">
                            <div class="font-medium text-sm">
                                @if (data.firstName || data.aliasName) { 
                                    {{ (data?.aliasName ? data.aliasName : (data?.firstName ? data.firstName : '-')) }}
                                } 
                                @else { - }
                            </div>
                            @if(data?.reliabilityPercentage){
                            <div class="text-xs text-muted-foreground">
                                {{data.reliabilityPercentage}}%
                                {{'guard-shift-details.onGoing.reliability' | translate}}
                            </div>
                            <div class="text-xs text-blue-600">
                                {{ data.totalShiftsForCustomer }}
                                {{'guard-shift-details.onGoing.passports-for-you' | translate}}
                            </div>
                            }
                        </div>
                    </div>
                    }
                </div>
            </div>
            <div class="space-y-[24px]">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <!-- Workplace Card -->
                    <div
                        class="bg-card rounded-lg p-4 border border-border shadow-sm">
                        <h3
                            class="font-semibold text-foreground mb-3 flex items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16"
                                height="16" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round"
                                class="lucide lucide-map-pin mr-2">
                                <path
                                    d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0">
                                </path>
                                <circle cx="12" cy="10" r="3"></circle>
                            </svg>
                            {{ 'guard-shift-details.onGoing.work-place' | translate }}
                        </h3>
                        <div class="text-sm text-muted-foreground">
                            {{ onGoinfShftData?.jobPlace?.jobPlaceName ? onGoinfShftData?.jobPlace?.jobPlaceName : '-' }}
                        </div>
                    </div>

                    <!-- Personnel Card -->
                    <div
                        class="bg-card rounded-lg p-4 border border-border shadow-sm">
                        <h3
                            class="font-semibold text-foreground mb-3 flex items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16"
                                height="16" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round"
                                class="lucide lucide-users mr-2">
                                <path
                                    d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                                <circle cx="9" cy="7" r="4"></circle>
                                <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                            </svg>
                            {{ 'guard-shift-details.onGoing.competency-requirements' | translate}}
                        </h3>
                        <div class="text-sm text-muted-foreground">
                            <!-- Replace this with real number -->
                            @if(onGoinfShftData?.skill?.name) {
                                {{onGoinfShftData?.skill?.name}} 
                            } @else{ - }
                        </div>
                    </div>
                </div>

                @if( onGoinfShftData?.description) {
                <div
                    class="group relative p-[16px] bg-card rounded-xl border border-border/50 shadow-sm hover:shadow-md transition-all duration-300">
                    <div class="flex items-center justify-between mb-[12px]">
                        <h3
                            class="text-[14px] font-semibold text-foreground flex items-center !mb-0">
                            <div class="p-[8px] rounded-lg bg-primary/10 !mr-0">
                                <svg xmlns="http://www.w3.org/2000/svg"
                                    width="16" height="16" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor"
                                    stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="lucide lucide-users">
                                    <path
                                        d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                                    <circle cx="9" cy="7" r="4"></circle>
                                    <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                                </svg>
                            </div>
                            {{'guard-shift-details.onGoing.job-description' | translate}}
                        </h3>
                    </div>
                    <p
                        class="text-sm text-muted-foreground leading-relaxed m-2">
                        {{ onGoinfShftData?.description }}
                    </p>
                </div>

                } @if (onGoinfShftData?.startTime && onGoinfShftData?.endTime) {
                <div
                    class="group relative p-[16px] bg-card rounded-xl border border-border/50 shadow-sm hover:shadow-md transition-all duration-300">
                    <div class="flex items-center justify-between mb-[12px]">
                        <h3
                            class="text-[14px] font-semibold text-foreground flex items-center !mb-0">
                            <div class="p-[8px] rounded-lg bg-primary/10 !mr-0">
                                <svg class="lucide lucide-clock !mr-0"
                                    fill="none" height="16"
                                    stroke="currentColor" stroke-linecap="round"
                                    stroke-linejoin="round" stroke-width="2"
                                    viewBox="0 0 24 24" width="16"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <polyline
                                        points="12 6 12 12 16 14"></polyline>
                                </svg>
                            </div>
                            {{'guard-shift-details.onGoing.working-hours' | translate}}
                        </h3>
                    </div>
                    <p class="text-sm text-muted-foreground font-medium m-2">
                        {{ onGoinfShftData?.startTime }} - {{ onGoinfShftData?.endTime }}
                    </p>
                </div>
                }
                <!-- Assignment summary component -->
                    @if(customer?.employeeRole?.id != 3)
                    {
                        <app-assigment-shift-summary-calculation
                            [costPerGuard]="onGoinfShftData.costPerGuard"
                            [duration]="onGoinfShftData.duration"
                            [guardCount]="onGoinfShftData.guardsNumber"
                            [totalCost]="onGoinfShftData.totalCost"></app-assigment-shift-summary-calculation>
                    }
            </div>
        </div>
    </div>
</div>